module.exports = __webpack_public_path__ + "assets/img/club_profile_my_favorites.65bbdf31.jpeg";